import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ProfileNextPremierOrderSection from '/component/partial/profile/ProfileNextPremierOrderSection';
import {withTranslation} from '/provider/TranslationProvider';
import {
  hasScheduledPremierOrderById,
  nextPremierOrderCurrencyCodeById,
  nextPremierOrderCvById,
  nextPremierOrderQvById,
  nextPremierOrderScheduledOnById,
  nextPremierOrderTotalById,
} from '/redux/selector/coach.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      hasScheduledOrder: hasScheduledPremierOrderById,
      orderScheduledOn: nextPremierOrderScheduledOnById,
      orderCv: nextPremierOrderCvById,
      orderQv: nextPremierOrderQvById,
      orderTotal: nextPremierOrderTotalById,
      orderCurrencyCode: nextPremierOrderCurrencyCodeById,
    }),
  ),
  withTranslation('screen.coachProfile.section.nextPremierOrder'),
)(ProfileNextPremierOrderSection);
